export const apiConfig = {
  resourceScopes: ['3e12ccee-015f-4acd-b51b-e8371cae9690/.default'],
};
